import CleaningIcon from '../Images/cleaning-icon.svg'


const additionalAreas = [
    {
        id: 11, 
        image: CleaningIcon,
        option: 'Bedroom',
        desc: ''  
    },{
        id: 12, 
        image: CleaningIcon,
        option: 'Bathroom',
        desc: ''  
    },{
        id: 13, 
        image: CleaningIcon,
        option: 'Toilet',
        desc: ''  
    },{
        id: 14, 
        image: CleaningIcon,
        option: 'Living Room',
        desc: ''  
    },{
        id: 15, 
        image: CleaningIcon,
        option: 'Kitchen',
        desc: ''  
    },{
        id: 16, 
        image: CleaningIcon,
        option: 'Garage',
        desc: ''  
    },{
        id: 17, 
        image: CleaningIcon,
        option: 'Balcony',
        desc: ''  
    },{
        id: 18, 
        image: CleaningIcon,
        option: 'Study Room',
        desc: ''  
    },{
        id: 19, 
        image: CleaningIcon,
        option: 'Utility Room',
        desc: ''  
    },{
        id: 20, 
        image: CleaningIcon,
        option: 'Dining Room',
        desc: ''  
    },
    
    {
        id: 21, 
        image: CleaningIcon,
        option: 'Guest Room',
        desc: ''  
    },{
        id: 22, 
        image: CleaningIcon,
        option: 'Office Room',
        desc: ''  
    },{
        id: 23, 
        image: CleaningIcon,
        option: 'Playroom',
        desc: ''  
    },{
        id: 24, 
        image: CleaningIcon,
        option: 'Gym Room',
        desc: ''  
    },{
        id: 25, 
        image: CleaningIcon,
        option: 'Attic',
        desc: ''  
    },
]




export default additionalAreas;